import type { QueryOptions } from "@tanstack/react-query"
import type { ExactPartial } from "@wagmi/core/internal"
import { Evaluate, getAddress } from "viem"
import {
  type GetAccountEnabledVaultsInfoErrorType,
  type GetAccountEnabledVaultsInfoParameters,
  type GetAccountEnabledVaultsInfoReturnType,
  getAccountEnabledVaultsInfo,
} from "../actions/getAccountEnabledVaultsInfo"
import type { ExtendedConfig, ScopeKeyParameter } from "../types"
import { filterQueryOptions } from "../utils"

export type GetAccountEnabledVaultsInfoOptions<
  config extends ExtendedConfig = ExtendedConfig,
> = Evaluate<
  ExactPartial<GetAccountEnabledVaultsInfoParameters<config>> &
    ScopeKeyParameter
>

export function getAccountEnabledVaultsInfoQueryKey<
  config extends ExtendedConfig = ExtendedConfig,
>(options: GetAccountEnabledVaultsInfoOptions<config> = {}) {
  const { account, ...parameters } = options

  return [
    "evcAccountEnabledVaultsInfo",
    filterQueryOptions({
      ...parameters,
      account: account && getAddress(account),
    }),
  ] as const
}

export function getAccountEnabledVaultsInfoQueryOptions<
  config extends ExtendedConfig,
>(config: config, options: GetAccountEnabledVaultsInfoOptions<config>) {
  return {
    gcTime: 0,
    async queryFn({ queryKey }) {
      const { scopeKey: _s, ...parameters } = queryKey[1]
      console.log(">>>> parameters", parameters)
      return getAccountEnabledVaultsInfo<config>(config, parameters)
    },
    queryKey: getAccountEnabledVaultsInfoQueryKey<config>(options),
  } satisfies QueryOptions<
    GetAccountEnabledVaultsInfoQueryFnData,
    GetAccountEnabledVaultsInfoErrorType,
    GetAccountEnabledVaultsInfoData,
    GetAccountEnabledVaultsInfoQueryKey<config>
  >
}

export type GetAccountEnabledVaultsInfoQueryFnData =
  GetAccountEnabledVaultsInfoReturnType

export type GetAccountEnabledVaultsInfoData =
  GetAccountEnabledVaultsInfoQueryFnData

export type GetAccountEnabledVaultsInfoQueryKey<
  config extends ExtendedConfig = ExtendedConfig,
> = ReturnType<typeof getAccountEnabledVaultsInfoQueryKey<config>>
